<div class="modal-header">
	<h4 class="modal-title fw-bold">
		<span jhiTranslate="germplasm-list.import-updates.header"></span>
        <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
			(click)="dismiss()">
	</button>
</div>
<div class="modal-body">
	<div class="mb-3 row">
		<div class="col">
			<span jhiTranslate="template.download.description"></span>&nbsp;<a href (click)="export($event)" jhiTranslate="template.download.here"></a>.
		</div>
	</div>
	<div class="mb-3 row">
		<div class="col-2"></div>
		<div class="col-md-8">
            <label class="form-label" for="fileUpload">
                <i class="fa fa-search"></i>&nbsp;<span jhiTranslate="germplasm-list.import.file.input.description"></span></label>
			<jhi-file-select id="fileUpload"
							 [acceptedFileTypes]="selectedFileType"
							 (fileSelected)="onFileChange($event)"
							 (fileCleared)="clearSelectedFile()">
			</jhi-file-select>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="dismiss()">
		<span jhiTranslate="cancel"></span>
	</button>
	<button (click)="next()" class="btn btn-primary" [disabled]="isLoading">
		<span *ngIf="isLoading" class="throbber throbber-btn"></span>
		<span jhiTranslate="next"></span>
	</button>
</div>
